export default __webpack_public_path__ + "static/media/EM0780.34I-21942_-14963_0.4b1739eb.jpg";